import {
	AdvertPanel as AdvertPanelData,
	HomePageBody,
	MatchDayCentreTakeover,
	SuperBanner as SuperBannerData,
	Takeover as TakeoverData,
	TeamStories as TeamStoriesData,
	TopStories as TopStoriesData,
	TopVideos as TopVideosData,
} from 'services/freeform';

import { AdvertPanel } from '@home/components/advert-panel';
import { EmbedBlock } from '@home/components/embed-block';
import { MatchDayTakeover } from '@home/components/match-day-takeover';
import { SuperBanner } from '@home/components/super-banner';
import { Takeover } from '@home/components/takeover';
import { TeamStories } from '@home/components/team-stories';
import { TopStories } from '@home/components/top-stories';
import { TopVideos } from '@home/components/top-videos';

import styles from './home-page.module.scss';

type HomePageProps = {
	body: HomePageBody;
};

type HomeControl =
	HomePageBody['main']['rows'][number]['columns'][number]['controls'][number];

const getControlType = (control: HomeControl): string => {
	if (control && typeof control === 'object' && 'type' in control) {
		return String((control as { type: unknown }).type);
	}
	return 'Unknown';
};

const renderControl = (control: HomeControl, index: number) => {
	const type = getControlType(control);
	const key = `${type}-${index}`;

	switch (type) {
		case 'Takeover':
			return <Takeover key={key} data={control as TakeoverData} />;
		case 'MatchDayCentreTakeover':
			return (
				<MatchDayTakeover
					key={key}
					data={control as MatchDayCentreTakeover}
				/>
			);
		case 'TopStories':
			return <TopStories key={key} data={control as TopStoriesData} />;
		case 'TopVideos':
			return <TopVideos key={key} data={control as TopVideosData} />;
		case 'TeamStories':
			return <TeamStories key={key} data={control as TeamStoriesData} />;
		case 'AdvertPanel':
			return <AdvertPanel key={key} data={control as AdvertPanelData} />;
		case 'SuperBanner':
			return <SuperBanner key={key} data={control as SuperBannerData} />;
		case 'Embed':
			return (
				<EmbedBlock
					key={key}
					script={(control as { script?: string }).script || ''}
				/>
			);
		default:
			console.warn(`Unsupported homepage control type: ${type}`);
			return null;
	}
};

export const HomePage = ({ body }: HomePageProps) => {
	const rows = body?.main?.rows ?? [];

	return (
		<div className={styles.root}>
			{rows.map((row, rowIndex) => (
				<div key={`row-${rowIndex}`} className={styles.row}>
					{row.columns.map((column, columnIndex) => (
						<div
							key={`col-${rowIndex}-${columnIndex}`}
							className={styles.column}
						>
							{column.controls.map((control, controlIndex) =>
								renderControl(control, controlIndex)
							)}
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default HomePage;
